// extracted by css-extract-rspack-plugin
export default {"cls1":"server_side_bulk_downloader-cls1_NTN","cls2":"server_side_bulk_downloader-cls2_Pnx server_side_bulk_downloader-cls1_NTN"};